// Horizontal swipe on an element - a finger or a pen, not a mouse (with a mouse there are
// buttons: e.g. Block Company Timeline's arrows), e.g. Block Company Timeline's whole block on
// mobile widths. Decided on release: far enough sideways and more sideways than up/down. The
// element needs touch-action: pan-y in its CSS, so vertical scrolling stays native and only the
// sideways movement is left to us - once the browser takes a gesture over as a scroll it sends
// pointercancel, which drops it here.
//
// No click to swallow after a swipe: browsers don't click after a touch that moved past their tap
// slop, far less than SWIPE_THRESHOLD.

// UNVERIFIED: our own pick - far enough that a sloppy tap or a mostly vertical scroll doesn't
// count, short enough for a flick of the thumb.
export const SWIPE_THRESHOLD = 40;

// The way the finger moved: "left" is the carousel's "next".
export type SwipeDirection = "left" | "right";

export interface SwipeOptions {
    onSwipe: (direction: SwipeDirection) => void;
    // Checked when a gesture starts (e.g. only at mobile widths).
    enabled?: () => boolean;
}

export function bindSwipe(element: HTMLElement, { onSwipe, enabled = () => true }: SwipeOptions): void {
    let start: { pointerId: number; x: number; y: number } | null = null;

    element.addEventListener("pointerdown", (event) => {
        start = event.pointerType !== "mouse" && event.isPrimary && enabled()
            ? { pointerId: event.pointerId, x: event.clientX, y: event.clientY }
            : null;
    });

    element.addEventListener("pointerup", (event) => {
        if (!start || event.pointerId !== start.pointerId) {
            return;
        }
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            onSwipe(dx < 0 ? "left" : "right");
        }
    });

    element.addEventListener("pointercancel", () => {
        start = null;
    });
}
